import React, { useState, useEffect } from 'react'
import { getBioDetail } from "data/Querys"
import { useQuery } from "react-query"
import Loader from 'components/general/Loader'
import MirsTable from 'components/general/table/Table'
import Moment from 'react-moment'
import { useSelector } from 'react-redux'
import { getGlobalProps } from 'state-management/selectors'
import Noc from 'components/presentation/Noc';
import Discipline from 'components/presentation/Discipline'
import { getAge, getHeight } from 'helpers/utils';
import PageHeader from 'components/common/PageHeader';
import Label from "components/general/Label"
import { DisciplineMemo } from 'components/presentation/Discipline';
import { ColumnEvent, ColumnMedal } from "components/common/schedule/TableColumns"
import { useGetDisciplines, useGetLanguages } from 'helpers/commonCodes';
import ReactDOM from 'react-dom';
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import { getDiscipline, getLevelRSC, getLongEventRSC, getRscObject } from "helpers/rsc"

function BioDetail() {
    const globalProps = useSelector(getGlobalProps);
    const params = useUrlFriendlyToParameters()
    const { mirs_competition, mirs_language, mirs_noc } = useUrlFriendlyToParameters()
    let paramsURL = { ...params }

    const dataDisciplines = useGetDisciplines({ mirs_competition: mirs_competition, mirs_language: mirs_language })
    const dataLanguage = useGetLanguages()
    const athleteCode = paramsURL['mirs_code'];
    const [showImage, setShowImage] = useState(true);
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, 'results')//useGetURL(paramsURL, 'results')

    const handleClick = (props) => {
        const rsc = props?.code;
        const objRsc = getRscObject(rsc)
        if (getLevelRSC(paramsURL["mirs_rsc"]) === "EVENT") {
            paramsURL["mirs_event_rsc"] = rsc
            paramsURL["mirs_rsc"] = undefined
            paramsURL["mirs_discipline"] = objRsc.discipline

        } else {
            //Phase or unit
            paramsURL["mirs_event_rsc"] = getLongEventRSC(rsc)
            paramsURL["mirs_rsc"] = rsc
            paramsURL["mirs_discipline"] = objRsc.discipline
        }
        setParamsUrl(paramsURL);
        if (rsc.indexOf('TMRY') === -1) {
            setShouldNavigate(true);
        }
    };

    const hideImg = (event) => {
        // this.setState({ showImg: false });
        setShowImage(false);
    };

    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['bioDetail', paramsURL['mirs_competition'], paramsURL['mirs_language'], paramsURL['mirs_code']],
            queryFn: getBioDetail,
            enabled: true
            // notifyOnChangeProps: [id] | "tracked"
        });


    function checkFileExists(fileUrl) {
        return fetch(fileUrl)
            .then(response => {
                if (response.status === 200) {
                    return true;  // El archivo existe
                } else {
                    return false; // El archivo no existe
                }
            })
            .catch(error => {
                return false; // Ocurrió un error al hacer la solicitud
            });
    }


    const columnsMedals = React.useMemo(
        () => [
            ColumnMedalDiscipline({ disableSort: true }),
            ColumnMedalEvent({ disableSort: true }),
            {
                Header: <Label data={'HeaderRank'} />,
                accessor: 'medal_type',
            },
            ColumnMedal({ disableSort: true })

        ])


    const columnsSchedules = React.useMemo(
        () => [
            {
                Header: <Label data={'HeaderStartTime'} />,
                accessor: 'startDate',
                id: 'StartTime',
                Cell: (props) => (<>
                    <Moment tz={globalProps.timezone} format="ddd, DDMMM">{props.value}</Moment><br />
                    <Moment tz={globalProps.timezone} format="hh:mm">{props.value}</Moment>
                </>)

            },

            {
                Header: <Label data={'HeaderLocation'} />,
                accessor: 'location.description',
                id: 'Location',
                Cell : props => <div className='text-wrap'>{props.cell.row.original?.location?.description}</div>
            },

            ColumnDiscipline({ disableSort: true }),

            {
                Header: <Label data='HeaderEvent' />,
                accessor: 'eventUnit.longDescription',
                className: 'schedule-event',
                headerClassName: 'schedule-event',
                disableSortBy: false,
                id: 'Event',
                Cell: props => <div className='text-wrap'>{props.cell.row.original?.eventUnit.longDescription}</div>
            },
          
            {
                Header: '',
                accessor: 'eventUnit.order',
                id: 'Order',
                Cell: props => <>#{props.cell.row.original?.eventUnit.order}</>
            },

            {
                Header: <Label data={'HeaderStatus'} />,
                accessor: 'status.description',
                id: 'Status'
            }

        ])

    data?.person?.medals?.forEach(item => {
        let eu = data?.person?.registeredEvents?.find(register => register?.event?.code === item?.event_code)?.event?.longDescription
        let disciplineCode = getDiscipline(item?.event_code)
        let discipline = dataDisciplines?.disciplines?.find(item => item.code === disciplineCode)?.description
        item.euDescription = eu
        item.discipline = discipline
        item.disciplineCode = disciplineCode
    })

    let hiddenColumns = Array.isArray(data?.person?.disciplines) && data?.person?.disciplines.length > 1 ? [] : ['ScheduleDiscipline']
    let language = dataLanguage?.languages?.find(item => item.lang === mirs_language?.toUpperCase())?.description;

    let fullPath = process.env.REACT_APP_SERVER_URL_RESOURCES + "/pic/";
    let longId = athleteCode.padStart(9, '0');
    fullPath += mirs_competition + "/";
    fullPath += longId.substring(0, 3) + "/" + longId.substring(3, 6) + "/";
    fullPath += athleteCode + ".jpg";

    //if (!checkFileExists(fullPath))
    //    fullPath = "/assets/images/photos/photo.webp";
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (<>
        <PageHeader title={<Label data="LabelBiographies" />} />
        <div className='mirs-page-container'>
            <div className="wrsBiosDetail__panel">
                {isError && <div>error</div>}
                {isLoading && <Loader />}
                {data && data.person && data.person.code &&

                    <div>
                        <h1 className="wrsBiosDetail__h1">{data.person.familyName.toUpperCase()} {data.person.givenName}</h1>
                        <div className="container-fluid mb-2">
                            <div className="row">
                                <div className="col-4">

                                    <picture>
                                        {showImage ? (
                                            <img className="wrsBiosDetail__image" alt={data.person.familyName} src={`${fullPath}`} onError={hideImg} />
                                        ) : (<img className="wrsBiosDetail__image" alt={data.person.familyName} src={`/assets/images/photos/photo.webp`} />)}
                                    </picture>

                                </div>
                                <div className="col-4">
                                    <div className="wrsNoc" >
                                        <div className="flag">
                                            <img
                                                aria-hidden="true"
                                                src={`/assets/images/flags/${data?.person?.organisation?.code}.png`}
                                            />
                                        </div>
                                        <Noc noc={data?.person?.organisation?.code} code={data?.person?.organisation?.description}></Noc>
                                    </div>
                                    {data?.person?.disciplines &&
                                        data?.person?.disciplines.map((item, key) => <div className="pt-2" key={item.code}><Discipline code={item.code} description={item.description} /></div>)
                                    }



                                    <div className="pt-2"><strong><Label data="HeaderBirthDate" />:</strong> <Moment parse="YYYY-MM-DD" format="D MMM YYYY">{data?.person?.birthDate}</Moment></div>
                                    <div className="pt-2"><strong><Label data="HeaderAge" />:</strong> {getAge(data?.person?.birthDate)}</div>
                                    <div className="pt-2"><strong><Label data="HeaderGender" />:</strong> {data?.person?.personGender?.description}</div>
                                    {data.person.height > 0 &&
                                        <div className="pt-2"><strong><Label data="HeaderHeight" /> (m/ft):</strong> {getHeight(data?.person?.height)}</div>
                                    }
                                </div>


                                    <div className="col-4">
                                        <div className="pt-2">&nbsp;</div>
                                        <div className="pt-2">&nbsp;</div>
                                        {data?.person?.participantBio?.placeofBirth && <div className="pt-2"><strong><Label data="LabelBirthPlace" />:</strong> {data?.person?.participantBio?.placeofBirth}</div>}
                                        {data?.person?.participantBio?.countryofBirth?.description && <div className="pt-2"><strong><Label data="HeaderBirthCountry" />:</strong> {data?.person?.participantBio?.countryofBirth?.description}</div>}
                                        {data?.person?.participantBio?.placeofResidence && <div className="pt-2"><strong><Label data="labelbioPLACE_OF_RESIDENCE" />:</strong> {data?.person?.participantBio?.placeofResidence}</div>}
                                        {data?.person?.participantBio?.countryofResidence?.description && <div className="pt-2"><strong><Label data="LabelResidenceCountry" />:</strong> {data?.person?.participantBio?.countryofResidence?.description}</div>}
                                    </div>

                            </div>
                        </div>
                    </div>

                }
                <div>
                    {data && data?.person && data?.person?.medals &&
                        <h2 className="wrsBiosDetail__h2"><Label data="LabelEventsMedals" />
                            < MirsTable
                                data={data?.person?.medals}
                                columns={columnsMedals}
                            />
                        </h2>
                    }
                </div>
                <div>
                    {data && data?.person && data?.person?.schedules &&
                        <h2 className="wrsBiosDetail__h2"><Label data="LabelCalendario" />
                            <MirsTable initialSortBy={[{ id: 'StartTime', desc: false }]}
                                data={data?.person?.schedules}
                                hiddenColumns={hiddenColumns}
                                columns={columnsSchedules}
                                rowOnClick={true}
                                rowClickHandler={handleClick}
                            />
                        </h2>
                    }
                </div>
                <div>
                    {data && data?.person && language !== 'EN' && language !== 'English' ?

                        <div className="container-fluid mb-2"><strong><Label data="LabelExtendedProfile" /></strong></div>
                        : ''
                    }
                    {data && data?.person && data?.person?.participantBio && (data?.person?.participantBio?.highlights || data?.person?.participantBio?.interest) &&
                        <div>
                            <h2 className="wrsBiosDetail__h2"><Label data="HeaderBiographicalInformation" />
                                <div className="container-fluid mb-2">
                                    <div className="row">
                                        <div className="col-8">

                                            {data?.person?.participantBio?.highlights && <div className="wrsNoc pt-2"><strong><Label data="HeaderHighlights" />:</strong></div>}
                                          
                                            {data?.person?.participantBio?.highlights?.map(hl=>(
                                                <div className="wrsNoc table" dangerouslySetInnerHTML={{ __html: hl.value }}></div>
                                            ))}

                                            {data?.person?.participantBio?.highlights?.value && <div className="wrsNoc" dangerouslySetInnerHTML={{ __html: data?.person?.participantBio?.highlights?.value }}></div>}

                                            {data?.person?.participantBio?.interest?.nickname && <div className="wrsNoc pt-2"><strong><Label data="LabelNickname" />:</strong></div>}
                                            {data?.person?.participantBio?.interest?.nickname && <div className="wrsNoc table" dangerouslySetInnerHTML={{ __html: data?.person?.participantBio?.interest?.nickname }}></div>}

                                            {data?.person?.participantBio?.interest?.prevNames && <div className="wrsNoc pt-2"><strong><Label data="labelbioPREVNAMES" />:</strong></div>}
                                            {data?.person?.participantBio?.interest?.prevNames && <div className="wrsNoc table" dangerouslySetInnerHTML={{ __html: data?.person?.participantBio?.interest?.prevNames }}></div>}
                                            
                                            {data?.person?.participantBio?.interest?.occupation && <div className="wrsNoc pt-2"><strong><Label data="LabelOccupation" />:</strong></div>}
                                            {data?.person?.participantBio?.interest?.occupation && <div className="wrsNoc table" dangerouslySetInnerHTML={{ __html: data?.person?.participantBio?.interest?.occupation }}></div>}
                                            
                                            {data?.person?.participantBio?.interest?.langSpoken && <div className="wrsNoc pt-2"><strong><Label data="LabelBio_LanguagesSpoken" />:</strong></div>}
                                            {data?.person?.participantBio?.interest?.langSpoken && <div className="wrsNoc table" dangerouslySetInnerHTML={{ __html: data?.person?.participantBio?.interest?.langSpoken }}></div>}
                                            
                                            {data?.person?.participantBio?.interest?.clubName && <div className="wrsNoc pt-2"><strong><Label data="labelbioCLUB_NAME" />:</strong></div>}
                                            {data?.person?.participantBio?.interest?.clubName && <div className="wrsNoc table" dangerouslySetInnerHTML={{ __html: data?.person?.participantBio?.interest?.clubName }}></div>}
                                            
                                            {data?.person?.participantBio?.interest?.coach && <div className="wrsNoc pt-2"><strong><Label data="labelbioCOACH" />:</strong></div>}
                                            {data?.person?.participantBio?.interest?.coach && <div className="wrsNoc table" dangerouslySetInnerHTML={{ __html: data?.person?.participantBio?.interest?.coach }}></div>}
                                            
                                            {data?.person?.participantBio?.interest?.hand && <div className="wrsNoc pt-2"><strong><Label data="labelbioHAND" />:</strong></div>}
                                            {data?.person?.participantBio?.interest?.hand && <div className="wrsNoc table" dangerouslySetInnerHTML={{ __html: data?.person?.participantBio?.interest?.hand }}></div>}
                                            
                                            {data?.person?.participantBio?.interest?.injuries && <div className="wrsNoc pt-2"><strong><Label data="labelbioINJURIES" />:</strong></div>}
                                            {data?.person?.participantBio?.interest?.injuries && <div className="wrsNoc table" dangerouslySetInnerHTML={{ __html: data?.person?.participantBio?.interest?.injuries }}></div>}
                                            
                                            {data?.person?.participantBio?.interest?.start && <div className="wrsNoc pt-2"><strong><Label data="labelbioSTART" />:</strong></div>}
                                            {data?.person?.participantBio?.interest?.start && <div className="wrsNoc table" dangerouslySetInnerHTML={{ __html: data?.person?.participantBio?.interest?.start }}></div>}
                                            
                                            {data?.person?.participantBio?.interest?.reason && <div className="wrsNoc pt-2"><strong><Label data="labelbioREASON" />:</strong></div>}
                                            {data?.person?.participantBio?.interest?.reason && <div className="wrsNoc table" dangerouslySetInnerHTML={{ __html: data?.person?.participantBio?.interest?.reason }}></div>}
                                            
                                            {data?.person?.participantBio?.interest?.training && <div className="wrsNoc pt-2"><strong><Label data="labelbioTRAINING" />:</strong></div>}
                                            {data?.person?.participantBio?.interest?.training && <div className="wrsNoc table" dangerouslySetInnerHTML={{ __html: data?.person?.participantBio?.interest?.training }}></div>}
                                            
                                            {data?.person?.participantBio?.interest?.hero && <div className="wrsNoc pt-2"><strong><Label data="labelbioHERO" />:</strong></div>}
                                            {data?.person?.participantBio?.interest?.hero && <div className="wrsNoc table" dangerouslySetInnerHTML={{ __html: data?.person?.participantBio?.interest?.hero }}></div>}
                                            
                                            {data?.person?.participantBio?.interest?.influence && <div className="wrsNoc pt-2"><strong><Label data="labelbioINFLUENCE" />:</strong></div>}
                                            {data?.person?.participantBio?.interest?.influence && <div className="wrsNoc table" dangerouslySetInnerHTML={{ __html: data?.person?.participantBio?.interest?.influence }}></div>}
                                            
                                            {data?.person?.participantBio?.interest?.philosophy && <div className="wrsNoc pt-2"><strong><Label data="labelbioPHILOSOPHY" />:</strong></div>}
                                            {data?.person?.participantBio?.interest?.philosophy && <div className="wrsNoc table" dangerouslySetInnerHTML={{ __html: data?.person?.participantBio?.interest?.philosophy }}></div>}
                                            
                                            {data?.person?.participantBio?.interest?.addInformation && <div className="wrsNoc pt-2"><strong><Label data="HeaderAddInformation" />:</strong></div>}
                                            {data?.person?.participantBio?.interest?.addInformation && <div className="wrsNoc table" dangerouslySetInnerHTML={{ __html: data?.person?.participantBio?.interest?.addInformation }}></div>}
                                            
                                            {data?.person?.participantBio?.interest?.extendedBios && <div className="wrsNoc pt-2"><strong><Label data="labelbioEXT_BIO_VALUE" />:</strong></div>}
                                            {data?.person?.participantBio?.interest?.extendedBios &&
                                                data?.person?.participantBio?.interest?.extendedBios.map((item, key) => <div className="wrsNoc pt-1" key={item.code}>{item.code}: {item.value}</div>)
                                            }
                                        </div>
                                    </div>
                                </div>
                            </h2>
                        </div>
                    }
                </div>
            </div>
        </div>
    </>);
}
export function ColumnMedalEvent({
    disableSort = true,
    label = "HeaderEvent",

}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'event_code',
            headerClassName: 'text-start w-25',
            id: 'Event',
            Cell: (props) => {
                return (
                    props.cell.row.original?.euDescription
                )
            }
        }
    )
}

export function ColumnDiscipline({
    disableSort = false,
    label = ""
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'location.locationOrder',
            className: 'text-start w-5 records-grid-body-discipline fw-bold',
            headerClassName: 'schedule-discipline',
            disableSortBy: disableSort,
            id: 'ScheduleDiscipline',
            Cell: props =><Discipline code={props.cell.row.original?.discipline?.code} />
        }   
    )
}

export function ColumnMedalDiscipline({
    disableSort = false,
    label = "HeaderDiscipline"
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'disciplineCode',
            headerClassName: 'schedule-discipline',
            disableSortBy: disableSort,
            id: 'MedalsDiscipline',
            className: 'text-start w-20 records-grid-body-discipline fw-bold',
            Cell: (props) => {
                return (
                    <DisciplineMemo code={props.cell.row.original?.disciplineCode} description={props.cell.row.original?.discipline} />
                )
            }
        }
    )
}

export default BioDetail


